export const imagesFormat = ['jpg', 'jpeg', 'png', 'gif'];

export const WORKSPACE_CONTENT_CONTAINER_ID = 'WORKSPACE_CONTENT_CONTAINER_ID';

export const TOUR_ID_FOR_WORKSPACES = 114777;
export const TOUR_ID_FOR_ACTION_ITEMS = 106612;
export const TOUR_ID_FOR_ASSISTANT_SETTINGS = 112319;
export const TOUR_ID_FOR_QUICKSTART_ADD_TEAMMATES = 114749;

export const END_OF_WORK_DAY_TIME = '19:00';
export const NOON_TIME = '12:00';

export const PLACEHOLDER_FOR_ACTION_ITEM = 'Add an item';
export const PLACEHOLDER_FOR_DISCUSSION_TOPIC = 'Add a topic';
export const PLACEHOLDER_FOR_SECTION_HEADER =
  'Add section title here. Create a new line (shift + enter) to add a description.'; // eslint-disable-line

export const billingStates = {
  FREE_TRIAL: 'free_trial',
  TRIAL_EXPIRED: 'trial_expired',
  FREE_PLAN: 'free_plan',
  PAID_PLAN: 'paid_plan',
  PAID_PLAN_PAYMENT_FAILED: 'paid_plan_payment_failed',
  PAID_PLAN_PREDICTIVEINDEX: 'paid_plan_predictiveindex',
};

export const shareMoodSettings = {
  VisibleToEveryone: 'everyone',
  OnlyVisibleToManagers: 'only_managers',
  VisibleToNoOne: 'visible_to_no_one',
};

export const meetingItemTypes = {
  action_item: 'Action item',
  discussion_topic: 'Discussion topic',
};

export const personalWorkspaceName = 'You (Private)';

export const suggestedTopics = [
  'I am blocked on...',
  'My Priorities this week are...',
  'I am worried about...',
  'Can you help me with...',
];

export const weekDaysOptions = [
  { label: 'M', value: 'Monday', dayNumber: 1 },
  { label: 'T', value: 'Tuesday', dayNumber: 2 },
  { label: 'W', value: 'Wednesday', dayNumber: 3 },
  { label: 'T', value: 'Thursday', dayNumber: 4 },
  { label: 'F', value: 'Friday', dayNumber: 5 },
  { label: 'S', value: 'Saturday', dayNumber: 6 },
  { label: 'S', value: 'Sunday', dayNumber: 0 },
];

export const managerAssistantSettingType = {
  PrepareForOneOnOne: 'ManagerAssistantSetting::PrepareForOneOnOne',
  FeedbackPrompt: 'ManagerAssistantSetting::FeedbackPrompt',
  GiveRecognition: 'ManagerAssistantSetting::GiveRecognition',
};

export const workspaceNotificationCardTypes = {
  Feedback: 'WorkspaceNotificationCard::Feedback',
  Kudos: 'WorkspaceNotificationCard::Kudos',
  FeaturePromotion: 'WorkspaceNotificationCard::FeaturePromotion',
  ConnectCalendar: 'WorkspaceNotificationCard::ConnectCalendar',
  GeneratedFromMeeting: 'WorkspaceNotificationCard::GeneratedFromMeeting',
  NewMeetingAttendeesFound: 'WorkspaceNotificationCard::NewMeetingAttendeesFound',
  FeedbackRequested: 'WorkspaceNotificationCard::FeedbackRequested',
  BidirectionalFeedback: 'WorkspaceNotificationCard::BidirectionalFeedback',
};

export const moodOptions = [
  {
    id: 'SAD_CRY',
    icon: 'sad-cry',
  },
  {
    id: 'ANGRY',
    icon: 'angry',
  },
  {
    id: 'MEH_ROLLING_EYES',
    icon: 'meh-rolling-eyes',
  },
  {
    id: 'MEH',
    icon: 'meh',
  },
  {
    id: 'SMILE_BEAM',
    icon: 'smile-beam',
  },
  {
    id: 'GRIN_BEAM',
    icon: 'grin-beam',
  },
  {
    id: 'GRIN_STARS',
    icon: 'grin-stars',
  },
];

export const screenBreakPoints = {
  screenSm: 576,
  screenMd: 768,
  screenLg: 992,
  screenXl: 1200,
};

export const defaultAvatarUrls = [
  'https://piprodperformassets.blob.core.windows.net/assets/charma_profile_blue.png',
  'https://piprodperformassets.blob.core.windows.net/assets/charma_profile_green.png',
  'https://piprodperformassets.blob.core.windows.net/assets/charma_profile_orange.png',
  'https://piprodperformassets.blob.core.windows.net/assets/charma_profile_pink.png',
  'https://piprodperformassets.blob.core.windows.net/assets/charma_profile_red.png',
  'https://piprodperformassets.blob.core.windows.net/assets/charma_profile_yellow.png',
];

export const cakeAvatarUrls = ['https://i.ibb.co/xYDxjBc/donut.png', 'https://i.ibb.co/Js6yDmR/cake.png'];

// As of 10/30/2023 we are prohibiting ALL consumer domains from being pioneers
export const consumerDomains = ['gmail.com', 'outlook.com', 'yahoo.com', 'aol.com', 'hotmail.com'];

export const acceptedProfilePictureFormats = '.png, .jpg, .jpeg';

export const pageContext = {
  GOAL_DETAIL_PAGE: 'GOAL_DETAIL_PAGE',
  HOME_PAGE: 'HOME_PAGE',
  WORKSPACE_PAGE: 'WORKSPACE_PAGE',
};

export const clickedFeedbackFormEvent = 'Clicked Feedback Form';
export const clickedKudosFormEvent = 'Clicked Kudos Form';
export const choseFeedbackTemplateEvent = 'Chose Feedback Template';
export const addedSurfaceItemToAgenda = 'Added Surface Item to Agenda';
